<template lang="html">
  <div>
    <div class="panel panel-info">
      <div class="panel-heading">
        <h3 class="panel-title">Equipos</h3>
      </div>
      <div class="panel-body">
        <table class="table table-bordered table-condensed table-hover">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Copa</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="team in teams">
              <td>{{ team.name }}</td>
              <td>
                <ul>
                  <li v-for="award in team.awards">{{ award.name }}</li>
                </ul>
              </td>
              <td>
                <button type="button" @click="select(team)" class="btn btn-success">
                  <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
                </button>
                <button type="button" @click="destroy(team)" class="btn btn-danger">
                  <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
                </button>
                <button type="button" @click="edit(team)" class="btn btn-default">
                  <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <modal :show.sync="show_modal" large="true" effect="fade" backdrop="false">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          Equipo: {{current_team.name}}
          <span v-for="award in team.awards" class="label label-info">{{ award.name }}</span>
        </h4>

      </div>
      <div slot="modal-body" class="modal-body">
        <div class="form-group">
          <label>Nombre</label>
          <input type="text" v-model="team.name">
        </div>
        <div class="form-group">
          <label>Copa</label>
          <select class="form-control" v-model="award_selected">
            <option></option>
            <option v-for="award in awards" :value="award.id" selected="{{ award.id == current_team.awards[0].id}}">
              {{ award.name }}
            </option>
          </select>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="closeModal">Cerrar</button>
        <button type="button" class="btn btn-primary" @click="saveTeam">Guardar</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Team from '../../api/team'
import {
  getConfigChampionship,
  getConfigTeams,
  getConfigTeam,
  getConfigAwards
} from '../../vuex/getters'
import * as actions from '../../vuex/actions'
import {modal} from 'vue-strap'
export default {
  vuex: {
    getters: {
      championship: getConfigChampionship,
      teams: getConfigTeams,
      current_team: getConfigTeam,
      awards: getConfigAwards
    },
    actions
  },
  data () {
    return {
      team: {
        id: null,
        name: null,
        championship_id: null,
        award: null
      },
      show_modal: false,
      award_selected: null
    }
  },
  ready () {
    this.fetchTeams()
  },
  methods: {
    fetchTeams () {
      this.$progress.start()
      let ApiTeam = new Team()
      ApiTeam.fetch(this.championship.id).then(response => {
        this.setConfigTeams(response.data)
        this.$progress.finish()
      }, error => {
        this.setError({show: true, message:'Failed fetching teams'})
        this.$progress.failed()
      })
    },
    destroy (team) {
      this.$progress.start()
      let ApiTeam = new Team()
      ApiTeam.delete(team.id).then(response => {
        this.removeConfigTeam(team)
        this.$progress.finish()
      }, error => {
        this.setError({show: true, message:'Este equipo ya tiene jugadores'})
        this.$progress.failed()
      })
    },
    select (team) {
      this.setConfigTeam(team)
      this.fetchTeams()
    },
    edit (team) {
      this.setConfigTeam(team)
      this.team = team
      this.show_modal = true
    },
    closeModal () {
      this.show_modal = false
    },
    saveTeam() {
      let ApiTeam = new Team()
      this.team.award = this.award_selected
      ApiTeam.put(this.team).then(response => {
        this.show_modal = false
        this.award_selected = null
        this.fetchTeams()
      }, error => {
        alert(error.message)
      })
    }
  },
  components: { modal }
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** TeamsList.vue?3f5506b9
 **/